/**
 * UI language derived from empresa country.
 * Extend with explicit user preference (e.g. configuracion.idioma_ui) when needed.
 */
export type UiLanguage = 'en' | 'es';

export function uiLanguageFromPais(pais: string | undefined | null): UiLanguage {
  if (pais === 'US') return 'en';
  return 'es';
}

/** BCP 47 tag for <html lang> */
export function htmlLangAttribute(lang: UiLanguage): string {
  return lang === 'en' ? 'en-US' : 'es';
}
